import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, styled } from '@mui/material';

import { iff } from '»utils/code';

export const ButtonTradingStyled = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'isCard' && prop !== 'isGrid' && prop !== 'buy',
})(({ theme, isCard, isGrid, buy }) => ({
  color: theme.palette.colors.onIconsAndTextButtons,
  width: isCard ? '40px' : iff(isGrid, '36px', '80px'),
  minWidth: isCard ? '40px' : iff(isGrid, '36px', '80px'),
  maxWidth: isCard ? '40px' : iff(isGrid, '36px', '80px'),
  height: isCard ? '40px' : iff(isGrid, '20px', '46px'),
  margin: isCard || isGrid ? 0 : '8px 8px 40px 4px',
  borderRadius: isCard || isGrid ? '5px' : '8px',
  backgroundColor: buy
    ? theme.palette.colors.tradingUp
    : theme.palette.colors.tradingDown,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: isCard || isGrid ? '12px' : '25px',
  '&:hover': {
    backgroundColor: theme.palette.colors.hoverHighlight,
  },
  '&:disabled': {
    backgroundColor: theme.palette.colors.off,
    color: theme.palette.colors.onIconsAndTextButtons,
  },
  padding: 0,
}));

export const ButtonRefreshStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.colors.onIconsAndTextButtonsVariant,
  width: '45px',
  minWidth: '45px',
  maxWidth: '45px',
  height: '32px',
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.refreshButton,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '18px',

  '&:hover': {
    backgroundColor: theme.palette.colors.highlight,
  },
  '&:disabled': {
    backgroundColor: theme.palette.colors.off,
  },
  '&:active': {
    backgroundColor: theme.palette.colors.highlight,
  },

  [theme.breakpoints.down('lg')]: {
    width: 64,
    maxWidth: 64,
    height: 40,
    fontSize: '24px',
  },
}));

export const ButtonUserStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.onPrimaryBackground,
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '24px',
  padding: 0,
  width: 'auto',
  minWidth: 'auto',

  [theme.breakpoints.up('lg')]: {
    fontSize: '20px',
    marginRight: '24px',
  },
}));

export const ButtonNavStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  minWidth: '45px',
  height: '32px',
  borderRadius: '5px',
  backgroundColor: 'transparent',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  marginTop: 15,
  marginLeft: 12,
  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.colors.highlight,
  },
  '&:disabled': {
    backgroundColor: 'transparent',
    color: theme.palette.colors.off,
  },
}));

export const ButtonGridStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'location' && prop !== 'hide',
})(({ theme, location, hide }) => ({
  color: theme.palette.colors.mainFocused,
  width:
    location === 'orderDetails'
      ? '106px'
      : location === 'card'
        ? '40px'
        : '30px',
  minWidth:
    location === 'orderDetails'
      ? '106px'
      : location === 'card'
        ? '40px'
        : '30px',
  maxWidth:
    location === 'orderDetails'
      ? '106px'
      : location === 'card'
        ? '40px'
        : '30px',
  height:
    location === 'card'
      ? '40px'
      : location === 'orderDetails'
        ? '32px'
        : '30px',
  margin: 0,
  borderRadius: '4px',
  backgroundColor:
    location === 'orderDetails'
      ? theme.palette.colors.secondaryDisabledBackground
      : theme.palette.colors.onIconsAndTextButtons,
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  '&:hover': {
    border: `solid 1px ${theme.palette.colors.mainFocused}`,
    backgroundColor: theme.palette.colors.onIconsAndTextButtons,
  },
  '&:disabled': {
    border: location !== 'orderDetails' && '0px',
    backgroundColor: theme.palette.colors.primaryBackground,
    color: theme.palette.colors.borderLine,
  },
  padding: 0,
  visibility: hide && 'hidden',
}));

export const ButtonGroupContainerStyled = styled(ButtonGroup)(({ theme }) => ({
  boxShadow: 'none',
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

export const ButtonViewStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ theme, selected }) => ({
  width: '45px',
  height: '32px',
  backgroundColor: selected
    ? theme.palette.colors.mainFocused
    : theme.palette.colors.off,
  color: theme.palette.colors.onIconsAndTextButtonsVariant,
  '&:hover': {
    backgroundColor: theme.palette.colors.mainFocused,
  },
  '&&:not(:last-of-type)': {
    borderRight: 'none',
  },
}));

export const ButtonIconStyled = styled(FontAwesomeIcon)(() => ({
  fontSize: '18px',
}));
